export const tr = {
    adjust: 'Netleştir',
    cancel: 'İptal',
    'phrase-with-minus-words': 'Negatif anahtar sözcükler içeren sözcük grubu',
    set: 'Tamam'
};
